import React from 'react';
import styled from 'styled-components';
import {
  FloatingNavigationContainer,
  NavigationHeader,
  NavigationTitle,
  NavigationSubtitle,
  NavigationContent,
  NavigationItem,
  NavigationItemText,
  StatusDot,
  FloatingNavigationCard,
} from './common';
import { useActiveTestStep } from '../../hooks/assessment-test/use-active-step';
import { useTestSectionScrollState } from '../../hooks/assessment-test/use-step-scroll-state';

export default function SideNavigation() {
  const { stepId, sectionId, step } = useActiveTestStep();

  const [isVisible, setIsVisible] = React.useState(false);
  React.useEffect(() => {
    setIsVisible(false);
    const timeoutId = window.setTimeout(() => setIsVisible(true), 1000);
    return () => window.clearTimeout(timeoutId);
  }, [stepId]);

  const { scrollTo } = useTestSectionScrollState();

  if (!step) {
    throw new Error(`Step with id ${stepId} not found`);
  }

  return (
    <>
      <FadeInWrapper $isVisible={isVisible}>
        <FloatingNavigationContainer>
          <FloatingNavigationCard>
            <NavigationHeader>
              <div>
                <NavigationTitle>{step.label}</NavigationTitle>
                <NavigationSubtitle>{step.title}</NavigationSubtitle>
              </div>
            </NavigationHeader>
            <NavigationContent>
              {step?.introduction && (
                <NavigationItem
                  isActive={sectionId === 'introduction'}
                  onClick={() => {
                    scrollTo('introduction');
                  }}
                >
                  <NavigationItemText isActive={false}>
                    Introduction
                  </NavigationItemText>
                </NavigationItem>
              )}
              {step.sections.map((section, index) => (
                <NavigationItem
                  key={`sidenav-item-${section.id}`}
                  isAnswered={section.isAnswered}
                  isActive={sectionId === section.id}
                  onClick={() => {
                    scrollTo(section.id);
                  }}
                >
                  <StatusDot
                    isAnswered={section.isAnswered}
                    isActive={sectionId === section.id}
                  />
                  <NavigationItemText isActive={sectionId === section.id}>
                    Question {index + 1}
                  </NavigationItemText>
                </NavigationItem>
              ))}
            </NavigationContent>
          </FloatingNavigationCard>
        </FloatingNavigationContainer>
      </FadeInWrapper>
    </>
  );
}

const FadeInWrapper = styled.div<{ $isVisible: boolean }>`
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: ${({ $isVisible }) => ($isVisible ? 'auto' : 'none')};
`;
